export default class CheckWorkerDuplicatesRequest {
    emailAddress = '';
    firstName = '';
    lastName = '';
}
